import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@tempmee/react';
import GoogleIcon from '../../images/GoogleIcon';

/** Starts Google SSO. A real button, so it takes focus and works from the keyboard. */
const GoogleLoginButton = ({ onClick }) => (
  <Button
    variant="outlined"
    color="secondary"
    className="w-full"
    startIcon={<GoogleIcon width="18px" height="18px" />}
    onClick={onClick}
  >
    Sign in with Google
  </Button>
);

GoogleLoginButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default GoogleLoginButton;
